/**
 * 이용약관 · 개인정보 처리방침 — 운영사: 주식회사 에이치제이브레인
 */
import React, { useState } from 'react';

const OPERATOR = '주식회사 에이치제이브레인';
const CONTACT = '이메일 info@hjbrain.com';
const EFFECTIVE = '2026년 10월 24일';
/** 사업자 정보 (사업자등록증 기준) */
const BIZ_INFO = [
  ['상호', '주식회사 에이치제이브레인 (hjbrain Co., Ltd.)'], ['대표자', '이선희'], ['사업자등록번호', '821-87-01635'],
  ['주소', '경기도 용인시 기흥구 구갈로60번길 9-1, 6층 602-A100호(구갈동, 라파빌딩)'], ['문의', 'info@hjbrain.com'],
];

const TERMS: [string, string[]][] = [
  ['제1조 (목적)', [`이 약관은 ${OPERATOR}(이하 "회사")가 제공하는 창고 패널 배치 도면 서비스(이하 "서비스")를 이용하는 데 필요한 회사와 이용자의 권리·의무와 책임을 정합니다.`]],
  ['제2조 (이용 신청과 승인)', [
    '이용자는 회사 정보·담당자 정보·사업자등록증을 제출해 이용을 신청하며, 회사가 확인 후 승인하면 이용할 수 있습니다.',
    '회사는 신청 내용이 사실과 다르거나 확인할 수 없는 경우 승인하지 않거나 반려할 수 있으며, 반려 사유를 안내합니다.',
  ]],
  ['제3조 (계정 관리)', [
    '이용 회사의 관리자는 소속 직원 계정을 만들고 관리하며, 계정과 비밀번호 관리 책임은 이용 회사에 있습니다.',
    '계정이 도용되었거나 의심되는 경우 즉시 회사에 알려야 합니다.',
  ]],
  ['제4조 (이용자의 자료)', [
    '이용자가 작성·저장한 도면과 견적 자료의 권리는 이용자에게 있으며, 회사는 서비스 제공 목적 외에 이를 이용하지 않습니다.',
    '각 이용 회사의 자료는 다른 이용 회사가 볼 수 없도록 분리해 보관합니다.',
  ]],
  ['제5조 (서비스의 결과물)', [
    '서비스가 계산하는 패널 분할·수량·재단표는 작업을 돕기 위한 참고 자료이며, 실제 제작·시공 전에 이용자가 확인해야 합니다.',
    '이용자의 확인 없이 결과물을 그대로 사용해 생긴 손해에 대해 회사는 고의 또는 중대한 과실이 없는 한 책임지지 않습니다.',
  ]],
  ['제6조 (이용 제한)', ['이용자가 법령이나 이 약관을 위반하거나 서비스 운영을 방해하는 경우 회사는 이용을 정지할 수 있으며, 그 사유를 안내합니다.']],
  ['제7조 (서비스 변경·중단)', ['회사는 점검·장애 등 부득이한 경우 서비스를 일시 중단할 수 있으며, 가능한 한 미리 알립니다.']],
  ['제8조 (이용 종료)', ['이용자는 언제든 이용 종료를 요청할 수 있으며, 회사는 요청에 따라 계정과 자료를 삭제합니다. 다만 법령에 따라 보관해야 하는 정보는 그 기간 동안 보관합니다.']],
  ['부칙', [`이 약관은 ${EFFECTIVE}부터 시행합니다.`]],
];

const PRIVACY: [string, string[]][] = [
  ['1. 수집 항목', ['필수: 상호, 사업자등록번호, 대표자, 담당자 이름, 담당자 이메일, 아이디, 비밀번호(복원할 수 없게 암호화 저장), 사업자등록증', '선택: 회사 전화, 주소, 담당자 휴대폰, 요청 사항', '자동 수집: 접속 IP, 접속·이용 기록']],
  ['2. 이용 목적', ['가입 신청 확인과 승인, 서비스 제공, 승인·비밀번호 찾기 등 안내 발송, 문의 응대, 부정 이용 방지']],
  ['3. 보관 기간', ['이용 종료(탈퇴) 요청 시까지 보관하고, 요청하면 지체 없이 삭제합니다. 반려된 신청은 반려일로부터 1년 후 삭제합니다.', '관련 법령에서 보관하도록 정한 정보는 그 기간 동안 보관합니다.']],
  ['4. 제3자 제공·위탁', ['법령에 따른 경우를 제외하고 제3자에게 제공하지 않습니다.', '안내 메일·문자 발송을 위해 발송 대행 업체에 이메일 주소·휴대폰 번호를 위탁할 수 있습니다.']],
  ['5. 이용자의 권리', ['이용자는 언제든 자신의 정보를 열람·정정·삭제하거나 처리 정지를 요청할 수 있습니다.']],
  ['6. 안전 조치', ['비밀번호 암호화, 접근 권한 제한, 회사별 자료 분리, 전송 구간 암호화(HTTPS)']],
  ['7. 개인정보 보호책임자·문의처', [`${OPERATOR} 대표 이선희 — ${CONTACT}`]],
  ['시행일', [`이 방침은 ${EFFECTIVE}부터 적용합니다.`]],
];

export const TermsDialog: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [tab, setTab] = useState<'terms' | 'privacy'>('terms');
  const doc = tab === 'terms' ? TERMS : PRIVACY;
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
      onMouseDown={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background: '#fff', borderRadius: 24, overflow: 'hidden', width: '100%', maxWidth: 640, maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', borderBottom: '1px solid #eee' }}>
          {([['terms', '이용약관'], ['privacy', '개인정보 처리방침']] as const).map(([k, l]) => (
            <button key={k} type="button" onClick={() => setTab(k)} style={{
              flex: 1, padding: 12, border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: tab === k ? 'bold' : 'normal',
              background: tab === k ? '#fff' : '#f5f5f5', borderBottom: tab === k ? '3px solid #3182F6' : '3px solid transparent',
            }}>{l}</button>
          ))}
        </div>
        <div style={{ overflow: 'auto', padding: '14px 20px', fontSize: 13, lineHeight: 1.7, color: '#333' }}>
          {doc.map(([h, ps]) => (
            <div key={h} style={{ marginBottom: 12 }}>
              <b>{h}</b>
              {ps.map((p, i) => <div key={i}>{ps.length > 1 ? `${i + 1}. ` : ''}{p}</div>)}
            </div>
          ))}
          <div style={{ marginTop: 16, padding: '10px 12px', background: '#f7f9fb', border: '1px solid #e3e8ee', borderRadius: 6, fontSize: 12, color: '#555' }}>
            <b>운영사 정보</b>
            {BIZ_INFO.map(([k, v]) => <div key={k}>{k}: {v}</div>)}
          </div>
        </div>
        <div style={{ padding: 12, borderTop: '1px solid #eee', textAlign: 'right' }}>
          <button type="button" onClick={onClose} style={{ height: 44, padding: '0 22px', border: 'none', borderRadius: 12, fontWeight: 600, fontSize: 15, background: '#3182F6', color: '#fff', cursor: 'pointer' }}>닫기</button>
        </div>
      </div>
    </div>
  );
};
